import React from 'react';
import { Box, VStack, StackDivider, Heading } from '@chakra-ui/react';
import EmailApprovalProgress from './EmailApprovalProgress';
import StepFunctionProgress from './StepFunctionProgress';
import BatchOperationsDetails from './BatchOperationDetails';

const BatchOperationProgressSteps = ({ timeStamp }) => {
  return (
    <VStack>
      <Heading>Batch operation progress</Heading>
      <br />
      <Box borderWidth="3px" borderRadius="lg" p="10" width="1050px">
        <BatchOperationsDetails timeStamp={timeStamp} />
        <VStack
          divider={<StackDivider borderColor="gray.200" />}
          spacing={10}
          align="stretch"
        >
          <EmailApprovalProgress status={timeStamp?.email_approval_status} />
          <StepFunctionProgress status={timeStamp?.batch_op_status} />
        </VStack>
      </Box>
    </VStack>
  );
};

export default BatchOperationProgressSteps;
